import {Component, OnInit} from '@angular/core';
import {AddOrganizationPolicyDocumentService} from '../../../shared/services/oganization/add-organization-policy-document.service';
import {OrganizationPolicyDocumentsRestService} from '../../../shared/services/oganization/organization-policy-documents-rest.service';
import {Subject} from 'rxjs';
import {ENTRY_STATES} from '../../../shared/types/entry/EntryStatesEnum';
import {PolicyDocumentType} from '../../../shared/types/organization/policy-document-type';
import {GlobalMessagesService} from '../../../shared/services/messages/global.messages.service';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'wsd-policy-documents-organization',
  templateUrl: './policy-documents.component.html',
  styleUrls: ['./policy-documents.component.css']
})
export class PolicyDocumentsComponent implements OnInit {

  filter = {
    name: ''
  };

  policyDocuments: PolicyDocumentType[];

  searchChanged = new Subject<void>();

  pageSize: number = 10;

  constructor(private addService: AddOrganizationPolicyDocumentService,
              private policyDocumentsRestService: OrganizationPolicyDocumentsRestService,
              private message: GlobalMessagesService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.searchChanged.pipe(
      debounceTime(500)
    ).subscribe(() => this.loadData(0));
  }

  onPageChange(event) {
    this.loadData(event.first / event.rows);
  }

  private loadData(page: number) {
    this.policyDocumentsRestService.search(this.filter.name).subscribe(
      (data: PolicyDocumentType[]) => {
        this.policyDocuments = data;
      });
  }

  modify(organizationPolicyDocument) {
    const organizationPolicyDocumentClone = _.cloneDeep(organizationPolicyDocument);
    this.addService.modify(organizationPolicyDocumentClone);
  }


  create() {
    this.addService.create();
  }

  search() {
    this.searchChanged.next();
  }

  onSave(event) {
    if (event.$state === ENTRY_STATES.NEW) {
      this.policyDocumentsRestService.create(event).subscribe({
        next: this.handleSuccess.bind(this),
        error: this.handleError.bind(this)
      });
    } else {
      this.policyDocumentsRestService.update(event).subscribe({
        next: this.handleSuccess.bind(this),
        error: this.handleError.bind(this)
      });
    }
  }

  private handleError() {
    this.message.showErrorMessage(this.translate.instant('WS_DIRECTORY.POLICY_DOCUMENTS.SAVE_ERROR_MESSAGE'));
  }

  private handleSuccess() {
    this.loadData(0);
    this.message.showSuccessMessage(this.translate.instant('WS_DIRECTORY.POLICY_DOCUMENTS.SAVED_MESSAGE'));
  }
}
